import { SEARCH_SERVICE_PROVIDERS, ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_VALUE, GRS_SEARCH_PROVIDER_SESSION_STORAGE_VALUE } from "../constants/grs.js";
const getIsGRSBetaEnabled = (isGRSFeatureFlagEnabled, isGRSBetaReleaseFeatureFlagEnabled, searchProviderSessionStorage) => {
  const isGRSSearchProviderSessionStorageSet = (searchProviderSessionStorage == null ? void 0 : searchProviderSessionStorage.toLowerCase()) === GRS_SEARCH_PROVIDER_SESSION_STORAGE_VALUE;
  return !!(isGRSFeatureFlagEnabled && isGRSBetaReleaseFeatureFlagEnabled && isGRSSearchProviderSessionStorageSet);
};
const getIsGRSPhasedReleaseEnabled = (isGRSFeatureFlagEnabled, isGRSBetaReleaseFeatureFlagEnabled, searchProviderLocalStorage) => {
  const isGRSSearchProviderLocalStorageSet = (searchProviderLocalStorage == null ? void 0 : searchProviderLocalStorage.toLowerCase()) === ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_VALUE;
  return !!(isGRSFeatureFlagEnabled && !isGRSBetaReleaseFeatureFlagEnabled && isGRSSearchProviderLocalStorageSet);
};
const getSearchProvider = (isGRSFeatureFlagEnabled, isGRSBetaReleaseFeatureFlagEnabled, searchProviderSessionStorage, searchProviderLocalStorage) => {
  if (typeof localStorage === "undefined") {
    return SEARCH_SERVICE_PROVIDERS.LUCIDWORKS;
  }
  const isGRSPhasedReleaseEnabled = getIsGRSPhasedReleaseEnabled(
    isGRSFeatureFlagEnabled,
    isGRSBetaReleaseFeatureFlagEnabled,
    searchProviderLocalStorage
  );
  const isGRSBetaEnabled = getIsGRSBetaEnabled(
    isGRSFeatureFlagEnabled,
    isGRSBetaReleaseFeatureFlagEnabled,
    searchProviderSessionStorage
  );
  const searchProvider = isGRSBetaEnabled || isGRSPhasedReleaseEnabled ? SEARCH_SERVICE_PROVIDERS.GRS : SEARCH_SERVICE_PROVIDERS.LUCIDWORKS;
  return searchProvider;
};
export {
  getIsGRSBetaEnabled,
  getIsGRSPhasedReleaseEnabled,
  getSearchProvider
};
